(ns quuppa.ui.icons
  "Reagent components to use SVG icons

  The icons.svg is generated in [quuppa-ui](https://gitlab.com/quuppa/qpe-cloud/quuppa-ui) project with `make icons` command."
  (:require-macros [quuppa.ui.icons])
  (:require [clojure.string :as str]
            [reagent.core :as r]))

(def icon-prefix "")

(def VALID-ICONS (quuppa.ui.icons/get-valid-icons "public/icons.svg"))

(defn svg-icon-url [icon-name]
  (str icon-prefix
       "icons.svg"
       ;; Add cache busting md5 hash
       "?v=" (quuppa.ui.icons/resource-hash "public/icons.svg")
       "#" (name icon-name)))

(defn svg-icon
"Use inside svg element to include svg icon
directly with <use> element."
  ([icon-name]
   (svg-icon icon-name nil))
  ([icon-name props]
   ; (assert (contains? VALID-ICONS (keyword icon-name))
   ;         (str "Icon must exist: " icon-name))
   [:use (assoc props :href (svg-icon-url icon-name))]))

(defn icon
"Use in html to include svg icon.

Creates `<svg>` element and refers to the icon with `<use>` element."
  ([icon-name]
   (icon icon-name nil))
  ([icon-name props]
   (let [[icon-name & classes] (str/split (some-> icon-name name) #"\.")]
     [:svg
      (r/merge-props {:role "img"
                      :class (into ["qi"
                                    (str "qi-" icon-name)]
                                   classes)}
                     (dissoc props :title))
      (svg-icon icon-name)
      [:title (or (:title props)
                  (str/capitalize icon-name))]])))

(defn arrow [props]
  [:div.qi-arrow props])

(defn circle [props]
  [:div.qi-circle props])
